export default {"src":"/_next/static/media/folderArrow.8aae2ddf.svg","height":22,"width":22};